import { ActionButton } from '@adobe/react-spectrum';
import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { doRefresh } from '../../../data/redux/slices/importSlice';
import Refresh from '@spectrum-icons/workflow/Refresh';
import { useDispatch } from 'react-redux';

export function BreadCrumbRefreshButton(props) {
    const dispatch = useDispatch();

    return (
        <ActionButton
            isDisabled={props?.isDisabled}
            aria-label="Refresh deck"
            onPress={() => {
                logEvent(getAnalytics(), 'preview_refresh', { url: props?.url });
                dispatch(doRefresh(props.url));
            }}
        >
            <span className="bcBtnLabel">Refresh</span>
            <Refresh />
        </ActionButton>
    );
}
